import { mapFirstImage } from '../DataTypes/imageMapper';
import { mapFirstLink } from '../DataTypes/linkMapper';

export interface Props {
	content: {
		contentType: 'slider';
		properties: {
			slides: {
				items: {
					content: {
						contentType: string;
						id: string;
						properties: {
							kicker: string;
							heading: string;
							text: {
								markup: string;
							};
							link: Umbraco.Link[];
							image: Umbraco.Image[];
							altText: string;
						};
					};
				}[];
			};
		};
	};
}

export const mapSlider = ({ content }: Props): Content.ContentModule => {
	const settings = { properties: { orientation: 'Vertical' } }; // Slider BlockList items have no settings and orientation is always Vertical
	return {
		documentType: content?.contentType,
		content: {
			properties: {
				slides:
					content.properties.slides?.items?.map((slide) => {
						return {
							content: {
								properties: {
									heading: slide.content.properties.heading,
									text: slide.content.properties.text?.markup ?? null,
									kicker: slide.content.properties.kicker ?? null,
									image: mapFirstImage(slide?.content?.properties?.image),
									altText: slide?.content?.properties?.altText ?? null,
									link: mapFirstLink(slide?.content?.properties?.link),
								},
							},
							settings,
						};
					}) ?? [],
			},
		},
	};
};
